export const fourg = {
  name: "fourg" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M9.825 17v-2.174h1.224V13.27H9.825V6.92H7.651L3.23 13.472v1.354h4.752V17h1.843ZM7.982 8.95v4.32h-2.88l2.88-4.32Zm10.901 4.19v1.844c-.533.418-1.195.634-1.915.634-1.843 0-3.226-1.527-3.226-3.658 0-2.131 1.383-3.629 3.226-3.629.965 0 1.9.389 2.534.994l1.282-1.181c-.95-.965-2.333-1.454-3.816-1.454-2.808 0-5.17 2.203-5.17 5.27 0 3.067 2.362 5.27 5.17 5.27 1.469 0 2.837-.561 3.816-1.526v-4.205h-3.845v1.642h1.944Z"/></svg>`,
  keywords: ["fourg"],
  category: "device" as const,
};
